import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);
const customRoutes = [
  { method: "GET", path: "/caregiver/:caregiverId", handlerName: "getByCaregiver" },
  { method: "GET", path: "/caregiver/:caregiverId/hours-summary", handlerName: "getHoursSummary" },
  { method: "GET", path: "/:id/certificate", handlerName: "downloadCertificate" },
  { method: "POST", path: "/:id/proof", handlerName: "uploadProof" },
  { method: "GET", path: "/:id/proof", handlerName: "downloadProof" },
];

const baseService = createCrudService("trainingRecords", customRoutes, router);

export const trainingRecordsService = {
  ...baseService,

  // Get training records for a caregiver (with running total based on hire-date training year)
  getByCaregiver: async (caregiverId, startDate, endDate) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    return api.getCall(`/api/trainingRecords/caregiver/${caregiverId}`, params);
  },

  // Get yearly hours summary for a caregiver
  getHoursSummary: async (caregiverId) => {
    return api.getCall(`/api/trainingRecords/caregiver/${caregiverId}/hours-summary`);
  },

  // Download certificate PDF
  getCertificateUrl: (recordId) => {
    return `/api/trainingRecords/${recordId}/certificate`;
  },

  // Upload external proof file
  uploadProof: async (recordId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.postCall(`/api/trainingRecords/${recordId}/proof`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  // Get proof download URL
  getProofUrl: (recordId) => {
    return `/api/trainingRecords/${recordId}/proof`;
  },

  // Create a manual training record
  create: async (data) => {
    return api.postCall("/api/trainingRecords", data);
  },
};
